var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import TrsTool from "./TrsTool.vue";
import TrsUrlImport from "./TrsUrlImport.vue";
import { Toast } from "@/composables/toast";
import { Services } from "../services";
import { getGalaxyInstance } from "@/app";
import { computed, ref, watch } from "vue";
import { getRedirectOnImportPath } from "../redirectPath";
import LoadingSpan from "@/components/LoadingSpan.vue";
import TrsServerSelection from "./TrsServerSelection.vue";
import { useRouter } from "vue-router/composables";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TrsImport',
    props: {
        queryTrsServer: {
            type: String,
            default: null,
        },
        queryTrsId: {
            type: String,
            default: null,
        },
        queryTrsVersionId: {
            type: String,
            default: null,
        },
        queryTrsUrl: {
            type: String,
            default: null,
        },
        isRun: {
            type: Boolean,
            default: false,
        },
    },
    setup(__props) {
        var _a;
        const props = __props;
        const trsTool = ref(null);
        const loading = ref(false);
        const importing = ref(false);
        const trsSelection = ref(null);
        const errorMessage = ref(null);
        const toolId = ref(props.queryTrsId);
        const isAnonymous = (_a = getGalaxyInstance().user) === null || _a === void 0 ? void 0 : _a.isAnonymous();
        const isAutoImport = ref(Boolean((props.queryTrsVersionId && props.queryTrsServer && props.queryTrsId) || props.queryTrsUrl));
        const toolIdTrimmed = computed(() => {
            var _a;
            return ((_a = toolId.value) === null || _a === void 0 ? void 0 : _a.trim()) || null;
        });
        const hasErrorMessage = computed(() => {
            return errorMessage.value != null;
        });
        watch(toolIdTrimmed, () => {
            onToolId();
        });
        const services = new Services();
        function onToolId() {
            return __awaiter(this, void 0, void 0, function* () {
                trsTool.value = null;
                errorMessage.value = null;
                if (!trsSelection.value || !toolIdTrimmed.value) {
                    return;
                }
                loading.value = true;
                try {
                    const tool = yield services.getTrsTool(trsSelection.value.id, toolIdTrimmed.value);
                    trsTool.value = tool;
                    if (isAutoImport.value) {
                        let versionField = "name";
                        const version = trsTool.value.versions.find((version) => {
                            if (version.name === props.queryTrsVersionId) {
                                return true;
                            }
                            else if (version.id === props.queryTrsVersionId) {
                                versionField = "id";
                                return true;
                            }
                        });
                        if (version) {
                            importVersion(trsSelection.value.id, trsTool.value.id, version[versionField], props.isRun);
                        }
                        else {
                            Toast.warning(`Specified version: ${props.queryTrsVersionId} doesn't exist`);
                            isAutoImport.value = false;
                        }
                    }
                }
                catch (error) {
                    trsTool.value = null;
                    errorMessage.value = error;
                }
                finally {
                    loading.value = false;
                }
            });
        }
        function onTrsSelection(selection) {
            trsSelection.value = selection;
            if (toolIdTrimmed.value) {
                onToolId();
            }
        }
        function onTrsSelectionError(message) {
            errorMessage.value = message;
        }
        const router = useRouter();
        function importVersion(trsId, toolIdToImport, version, isRunFormRedirect = false) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!trsId || !toolIdToImport) {
                    errorMessage.value = "Import Failed. Unknown Id";
                    return;
                }
                importing.value = true;
                errorMessage.value = null;
                try {
                    const response = yield services.importTrsTool(trsId, toolIdToImport, version);
                    const path = getRedirectOnImportPath(response, isRunFormRedirect);
                    router.push(path);
                }
                catch (error) {
                    errorMessage.value = error || "Import failed for an unknown reason.";
                }
                finally {
                    importing.value = false;
                }
            });
        }
        function importVersionFromUrl(url, isRunFormRedirect = false) {
            return __awaiter(this, void 0, void 0, function* () {
                importing.value = true;
                errorMessage.value = null;
                try {
                    const response = yield services.importTrsToolFromUrl(url);
                    const path = getRedirectOnImportPath(response, isRunFormRedirect);
                    router.push(path);
                }
                catch (error) {
                    errorMessage.value = error || "Import failed for an unknown reason.";
                }
                finally {
                    importing.value = false;
                }
            });
        }
        return { __sfc: true, props, trsTool, loading, importing, trsSelection, errorMessage, toolId, isAnonymous, isAutoImport, toolIdTrimmed, hasErrorMessage, services, onToolId, onTrsSelection, onTrsSelectionError, router, importVersion, importVersionFromUrl, TrsTool, TrsUrlImport, LoadingSpan, TrsServerSelection };
    }
});
